// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { ActionIcon, Group, Paper, Title } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import dayjs from 'dayjs';
import type { JSX } from 'react';

interface WeekNavigatorProps {
  weekStart: Date;
  onPrev: () => void;
  onNext: () => void;
}

export function WeekNavigator({ weekStart, onPrev, onNext }: WeekNavigatorProps): JSX.Element {
  const start = dayjs(weekStart);
  const end = start.add(6, 'day');

  let label: string;
  if (start.month() === end.month()) {
    label = `${start.format('MMMM D')}–${end.format('D, YYYY')}`;
  } else if (start.year() === end.year()) {
    label = `${start.format('MMMM D')} – ${end.format('MMMM D, YYYY')}`;
  } else {
    label = `${start.format('MMMM D, YYYY')} – ${end.format('MMMM D, YYYY')}`;
  }

  return (
    <Paper bg="gray.0" radius="md" p="sm">
      <Group justify="space-between" align="center">
        <ActionIcon variant="subtle" onClick={onPrev} aria-label="Previous week">
          <IconChevronLeft size={18} />
        </ActionIcon>
        <Title order={4} fw={700}>
          {label}
        </Title>
        <ActionIcon variant="subtle" onClick={onNext} aria-label="Next week">
          <IconChevronRight size={18} />
        </ActionIcon>
      </Group>
    </Paper>
  );
}
